import { createAsyncThunk } from "@reduxjs/toolkit";
import { Operator } from "../types/get-operators";

export const fetchOperators = createAsyncThunk(
  "operator/fetchOperators",
  async () => {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/operators`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch operators");
    }

    return response.json() as Promise<Operator[]>;
  }
);
